import {FtpFileConfiguration} from './FtpFileConfiguration';

export class MoveFtpFileConfiguration extends FtpFileConfiguration {
exitStatusOnMovedFile: boolean | null;
exitStatusOnNoFile: boolean | null;
outCnxCode: string;
}

